<template>
    <div>
        <ActionButtons :selected="selected" @print="print" />
        <PreTrialFilter :filter-model="filter" @applyFilter="applyFilter" @resetFilter="resetFilter" />
        <PreTrialDataTable
            :itemsLength="itemsLength"
            :is-loading="isLoading"
            :selected.sync="selected"
            :items="notices"
            :headers="headers"
            :page.sync="page"
            :isContract="true"
            @sendEmailNotification="sendEmailNotification"
            @handDocument="handDocument"
            @getSignedDocument="getSignedDocument"
            @deleteNotice="deleteNotice"
        />
        <PreTrialDetails ref="details" :details="noticeDetails" @saveDocument="saveDocument" @submit="submit" @applyFilter="applyFilter" />
    </div>
</template>
<script>
import ActionButtons from '@/components/pre-trial-notices/ActionButtons.vue';
import PreTrialFilter from '@/components/pre-trial-notices/PreTrialFilter.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import translate from '@/utils/translate.util';
import PreTrialDataTable from '@/components/pre-trial-notices/PreTrialDataTable.vue';
import ContractsService from '@/services/apiRequests/contracts.service';
import PreTrialDetails from '@/components/pre-trial-notices/PreTrialDetails.vue';
import FileService from '@/services/apiRequests/file.service';

export default {
    name: 'ContractsNotices',
    components: { PreTrialDetails, PreTrialDataTable, PreTrialFilter, ActionButtons },
    data: function() {
        return {
            filter: {
                main_dolg: null,
                name: null,
                serial_number: null,
                selectedAddress: {},
                doc_create_date: [],
                doc_delivery_date: [],
                doc_signed: null,
                doc_delivered: null
            },
            selected: [],
            page: 1
        };
    },
    watch: {
        page: {
            handler(newPage, oldPage) {
                if (newPage === 1) {
                    this.setNoticesPage(0);
                } else if (oldPage < newPage) {
                    this.setNoticesPage(this.paginationOptions.page + this.paginationOptions.itemsPerPage);
                } else {
                    this.setNoticesPage(this.paginationOptions.page - this.paginationOptions.itemsPerPage);
                }
                this.getPreTrialNotices();
            },
            immediate: true
        }
    },
    computed: {
        ...mapGetters('contracts', ['getNotices', 'getNoticesLoading', 'getNoticesLength', 'getNoticesPaginationOptions', 'getNoticeDetails']),
        headers() {
            return [
                {
                    text: 'Номер договора/<br>Контрагент',
                    value: 'serial_number'
                },
                {
                    text: 'Адрес',
                    value: 'address_full_name'
                },
                {
                    text: 'Дата создания/<br>Дата вручения',
                    value: 'doc_create_date'
                },
                {
                    text: 'Общая сумма<br>задолженности<br><br>Сумма долга<br>по основным<br>услугам<br><br>Сумма долга<br>по пене',
                    value: 'debt'
                },
                {
                    text: 'Платежи',
                    value: 'payment'
                },
                {
                    text: 'Комментарий',
                    value: 'doc_comment'
                },
                {
                    text: 'Документ<br>подписан',
                    value: 'doc_signed'
                }
            ];
        },
        notices() {
            return translate(this.getNotices, 'full', this.$i18n.locale);
        },
        isLoading() {
            return this.getNoticesLoading;
        },
        itemsLength() {
            return this.getNoticesLength;
        },
        paginationOptions() {
            return this.getNoticesPaginationOptions;
        },
        noticeDetails() {
            return translate(this.getNoticeDetails, 'full', this.$i18n.locale);
        }
    },
    methods: {
        ...mapMutations('contracts', ['setNoticesPage']),
        ...mapActions('contracts', ['getPreTrialNotices', 'setNoticesFilterOptions', 'printNoticePdf', 'setPreTrialNoticeDetails']),
        ...mapActions('base', ['showMessage']),
        applyFilter() {
            this.setNoticesFilterOptions({ ...this.filter });
            this.page = 1;
            this.getPreTrialNotices();
        },
        resetFilter() {
            this.filter = {
                main_dolg: null,
                name: null,
                serial_number: null,
                selectedAddress: {},
                doc_create_date: null,
                doc_delivery_date: null,
                doc_signed: null,
                doc_delivered: null
            };
            this.page = 1;
            this.setNoticesFilterOptions({ ...this.filter });
            this.getPreTrialNotices();
        },
        async print() {
            const selectedPreTrials = this.selected.map(item => item.id);
            await this.printNoticePdf(selectedPreTrials);
        },
        async sendEmailNotification(emailData) {
            await ContractsService.sendPdfToEmail(emailData);
            await this.showMessage({ message: 'Досудебное уведомление отправлено', color: 'success' });
        },
        async handDocument(id) {
            this.$refs.details.showDialog();
            await this.setPreTrialNoticeDetails(id);
        },
        async saveDocument({ form, files }) {
            const response = await ContractsService.editPreTrialNoticeDetails(form);
            if (response.successfull) {
                await FileService.downloadFile({ files, guid: this.noticeDetails.guid, document: 'contract_notice' });
            }
            this.$refs.details.closeDialog();
        },
        async submit({ form, files, completeSubmit }) {
            const response = await ContractsService.editPreTrialNoticeDetails(form);
            if (response.successfull) {
                await FileService.downloadFile({ files, guid: this.noticeDetails.guid, document: 'contract_notice' });
                completeSubmit();
            }
        },
        async getSignedDocument(guid) {
            //this.isLoading = true;
            const response = await this.$store.dispatch('documents/getSignedDocument', {
                guid: guid
            });

            if (!response) {
                this.$store.dispatch('base/showMessage', {
                    message: 'Нет данных',
                    color: 'warning'
                });
            }
            //this.isLoading = false;
        },
        async deleteNotice(record_id) {
            const response = await ContractsService.deleteContractPreTrialNotice(record_id);
            this.getPreTrialNotices();
        }
    }
};
</script>

<style scoped></style>
